import React from 'react';

import {TableMerchant} from '../../../../../helpers/Table/';
import {generateActionsList} from "./utils/generateActionsList";
import {columnsList} from "./constants/columnsList";
import {reportGenerationParams} from "./constants/reportGenerationParams";
import Caption from "../../../../../dumb/Caption/C";
import {Box} from "@material-ui/core";
import {apiV2WithdrawList} from "../../../../../../api/merchant/withdraw";
import getDateRange from "../../../../../dumb/IntervalFilterCustom/utils/getDateRange";
import {INTERVAL_YEAR} from "../../../../../dumb/IntervalFilterCustom/constants/intervals";
import {isUserAccessed} from "../../../../../../emitters/account";
import {PERMISSION_PAYOUT_HISTORY, PERMISSION_WITHDRAW} from "../../../../../../constants/permissions";

const getRowsFromServer = ({offset, limit, asset_code, ...rest}) => {
  // console.log(asset_code);
  return apiV2WithdrawList({offset, limit, asset_code, ...rest}).catch((err) => {
    return ({list: [], count: 0});
  });
};

module.exports = ({assetCode, topBlockHeight = 0, showTitle}) => {
  const getDataFromServer = (props) => {
    return getRowsFromServer({...props, asset_code: assetCode});
  }

  if (!isUserAccessed(PERMISSION_PAYOUT_HISTORY)) return <span />;

  return (
    <>
      {showTitle && (
        <Caption>
          Payout
        </Caption>
      )}
      <Box width="100%" height={`calc(100vh - ${265 + topBlockHeight}px)`} minHeight="500px">
        <TableMerchant
          getDataFromServer={getDataFromServer}
          report={reportGenerationParams(assetCode)}
          columns={columnsList}
          actions={(row) => (
            generateActionsList(row)
          )}
          reloadOnPropsChange={assetCode}
        />
      </Box>
    </>
  )
}
